import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Tick from './tick.json';

const Lottie = dynamic(() => import('react-lottie'), { ssr: false });
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { FacebookShareButton, TwitterShareButton } from 'react-share';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

let nftUrl;
export default function SuccessDialog(props) {
  const router = useRouter();

  const [loading, setloading] = useState(false);
  const userWalletRedux = useSelector(
    (state) => state.walletReducer.walletData,
  );
  useEffect(() => {
    if (props.manageNftPath) {
      nftUrl = `${window.location.origin}/nft/${props.manageNftPath}`;
    }
  }, [props.manageNftPath]);

  const handleClose = () => {
    props.setdialogState(false);
  };
  // console.log("window check", router.pathname,router,window.locations)

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          width: 380,
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 999 }}
      maxWidth="sm"
      onClose={handleClose}
    >
      <div>
        <div className="dialog-titlebar">
          <div className="dialog-close">
            <button
              className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300 closeButton"
              type="button"
              onClick={handleClose}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div>
          <DialogContent>
            <div>
              <div className="h-20 mt-4 flex justify-center">
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: Tick,
                  }}
                  speed={1}
                  style={{ margin: 'auto', width: '100%' }}
                />
              </div>
              <div className="py-4 px-16 text-center ">
                <label className="text-black text-base font-medium text-center mb-4">
                  You have successfully minted NFT!
                </label>
              </div>
              <div className="my-4 py-3 px-3 border rounded-md">
                <div className="px-4 py-2 flex">
                  <div className="text-gray-500">Contract Transaction ID</div>
                </div>
                <div className="px-4 py-2 flex">
                  <a
                    href={'https://whatsonchain.com/tx/' + props.contractTxid}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="link">
                      {props.contractTxid.slice(0, 25)}...
                    </div>
                  </a>
                </div>
                <div className="px-4 py-2 flex">
                  <div className="text-gray-500">Issuance Transaction ID</div>
                </div>
                <div className="px-4 py-2 flex">
                  <a
                    href={'https://whatsonchain.com/tx/' + props.issueTxid}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="link">
                      {props.issueTxid.slice(0, 25)}...
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              justifyContent: 'center',
              boxSizing: 'border-box',
              flexDirection: 'column',
            }}
          >
            <div className="w-full px-4 mb-5">
              <button
                className="dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                type="button"
                onClick={() => {
                  let path;
                  // if (Number(props.NftQty) > 1) {
                  //   path = "/collection/edit/" + props.manageNftPath;
                  // } else {
                  //   path = "/manageNFT/" + props.manageNftPath;
                  // }
                  path = '/manageNFT/' + props.manageNftPath;

                  router.push(path);
                }}
              >
                Continue
              </button>
            </div>

            {(() => {
              if (loading) {
                return (
                  <div className="flex justify-center	w-full">
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                );
              } else {
                return (
                  <div className="w-full mb-4 px-4 text-center">
                    {/* <button
                      className="bg-white text-gray-500 mx-2 my-2 font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
                      type="button"
                    >
                      <a
                        href="https://www.facebook.com/musicart.nft"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-facebook-square" />
                      </a>
                    </button>

                    <button
                      className="bg-white text-gray-500 mx-2 my-2 font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
                      type="button"
                    >
                      <a
                        href="https://twitter.com/MusicArt_nft"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-twitter" />
                      </a>
                    </button>

                    <button */}
                    {/* className="bg-white text-gray-500 mx-2 my-2 font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300" */}
                    {/* type="button" */}
                    {/* >
                      <a
                        href="https://www.instagram.com/MusicArt.nft"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-instagram" />
                      </a> */}
                    {/* </button> */}

                    {/* <button
                      className="bg-white text-gray-500 mx-2 my-2 font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
                      type="button"
                    >
                      <i className="fab fa-pinterest"></i>
                    </button> */}
                  </div>
                );
              }
            })()}
          </DialogActions>
        </div>
      </div>
    </Dialog>
  );
}
